import apiClient from "../client.js";
import { API_URLS } from "../urls.js";

// Get all leads
export const getLeads = ({
  page = 1,
  page_size = 10,
  category,
  property_id,
  agent_id,
  source,
  intent,
  sort = "latest",
} = {}) =>
  apiClient.get(API_URLS.LEADS.LIST, {
    params: {
      page,
      page_size,
      ...(category && category !== "All" ? { category } : {}),
      ...(property_id && property_id !== "All" ? { property_id } : {}),
      ...(agent_id && agent_id !== "All" ? { agent_id } : {}),
      ...(source && source !== "All" ? { source } : {}),
      ...(intent && intent !== "All" ? { intent } : {}),
      sort: sort === "Latest" ? "latest" : "oldest",
    },
  });

// Get single lead
export const getLead = (id) => apiClient.get(API_URLS.LEADS.DETAIL(id));

// Export leads
export const exportLeads = () =>
    apiClient.get(API_URLS.LEADS.EXPORT, {
      responseType: "blob",
      transformResponse: [(data) => data], // 🔥 prevents interceptor transform issues
    });

export const resendLead = (id) => apiClient.post(API_URLS.LEADS.RESEND(id));

export const resetLeadStatus = (id) => apiClient.post(API_URLS.LEADS.RESET_STATUS(id));